var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#EAEBEE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23c1.578 0 3.06-.302 4.449-.905 1.388-.603 2.61-1.434 3.667-2.49 1.057-1.058 1.885-2.278 2.485-3.662.6-1.385.899-2.865.899-4.443 0-1.578-.3-3.058-.9-4.443-.599-1.384-1.429-2.606-2.49-3.667-1.06-1.061-2.285-1.891-3.673-2.49-1.388-.6-2.871-.9-4.449-.9-1.562 0-3.037.3-4.425.9-1.388.599-2.612 1.429-3.673 2.49C2.329 4.45 1.499 5.673.9 7.057.3 8.442 0 9.922 0 11.5c0 1.578.302 3.058.905 4.443.603 1.384 1.434 2.604 2.49 3.661 1.058 1.057 2.28 1.888 3.668 2.49C8.451 22.699 9.93 23 11.5 23zm-.012-6.306c-.331 0-.587-.107-.769-.32-.181-.212-.272-.489-.272-.828v-3.005H7.264c-.339 0-.617-.09-.834-.272-.217-.181-.325-.434-.325-.757 0-.331.106-.59.32-.775.212-.185.492-.278.84-.278h3.182V7.264c0-.339.09-.613.272-.822.182-.209.438-.313.77-.313.323 0 .579.102.768.307.19.205.284.481.284.828v3.195h3.195c.355 0 .635.093.84.278.205.185.307.444.307.775 0 .323-.106.576-.32.757-.212.181-.488.272-.827.272H12.54v3.005c0 .355-.094.635-.284.84-.19.205-.445.308-.769.308z",
    transform: "translate(-49 -309) translate(16 287) translate(33 22)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusGray);
export default __webpack_public_path__ + "static/media/ic_plus_gray.7dc0701e907ed93fb784f4ce697de517.svg";
export { ForwardRef as ReactComponent };